import type { CompetitionDraft } from "@/types";

export const defaultCompetitionDraft: CompetitionDraft = {
  name: "Weekend Walk Challenge",
  description: "A friendly challenge to see who can stack the most steps before Monday.",
  type: "step_race",
  startDate: "2026-05-30",
  endDate: "2026-06-07",
  visibility: "invite-only",
};
